import React, { Component } from "react"
import GrabAndGoImage from "../images/grab_and_go.jpg"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 800;
  padding-top: 2rem;
  padding-bottom: 2rem;
  user-select: none;
`

const GrabAndGo = styled.div`
  display: flex;
  justify-content: center;
  alignItems: center;
`

const ImageBox = styled.div`
   max-width: 4rem;
`

const Image = styled.img`
  display: block;
  width: 100%;
`

const GrabAndGoLabel = styled.div`
  margin-left: 1.2rem;
  margin-right: 1.6rem;
  color: #C2171D;
  textTransform: uppercase;
  transform: translateY(.2rem);
`

const StorePickupLabel = styled.div`
  transform: translateY(.2rem);
  color: #616161;
`

const PostBanner = () => {
  return (
    <Container>
      <GrabAndGo>
        <ImageBox>
          <Image src={GrabAndGoImage} />
        </ImageBox>
        <GrabAndGoLabel>Grab & Go</GrabAndGoLabel>
      </GrabAndGo>
      <StorePickupLabel>Store pick-up</StorePickupLabel>
    </Container>
  )
}

export default PostBanner
